import { render, staticRenderFns } from "./GroupCard.vue?vue&type=template&id=ba32bf5a&scoped=true&"
import script from "./GroupCard.vue?vue&type=script&lang=js&"
export * from "./GroupCard.vue?vue&type=script&lang=js&"
import style0 from "./GroupCard.vue?vue&type=style&index=0&id=ba32bf5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba32bf5a",
  null
  
)

export default component.exports